// authService.js
// Centralized authentication helpers for MSAL/Entra ID
import { loginRequest } from '../authConfig';

export async function getAccessToken(msalInstance, account) {
    if (!msalInstance || !account) throw new Error('Not logged in');
    try {
        const response = await msalInstance.acquireTokenSilent({ ...loginRequest, account });
        return response.accessToken;
    } catch (error) {
        if (error.name === 'InteractionRequiredAuthError') {
            const response = await msalInstance.acquireTokenPopup({ ...loginRequest, account });
            return response.accessToken;
        }
        throw error;
    }
}

export async function getApiToken(msalInstance, account) {
    if (!msalInstance || !account) throw new Error('Not logged in');
    try {
        const response = await msalInstance.acquireTokenSilent({ account, scopes: loginRequest.scopes });
        // Use idToken: for OIDC-only scopes, CIAM signs the id_token with its own JWKS.
        // The accessToken for OIDC scopes targets Microsoft Graph and cannot be validated
        // against the CIAM JWKS endpoint.
        return response.idToken;
    } catch (error) {
        console.error('API token acquisition failed:', error);
        const response = await msalInstance.acquireTokenPopup({ account, scopes: loginRequest.scopes });
        return response.idToken;
    }
}
